import Vue from 'vue'
import VueRouter from 'vue-router'
import Intro from '@/views/Intro'
import Calculator from '@/views/Calculator'

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'Intro',
		component: Intro,
		meta: {
			order: 0
		}
	},
	{
		path: '/calculator/:tab?',
		name: 'Calculate Your Usage',
		component: Calculator,
		meta: {
			order: 1
		}
	}
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

export default router
